export const createGradeOptions = array => {
  return array.map(({ gradeName }) => {
    return {
      key: gradeName,
      name: gradeName,
    }
  })
}

export const createSiteOptions = array => {
  return [...array]
    .sort((a, b) =>
      (a.name ?? '').localeCompare(b.name ?? '', undefined, {
        sensitivity: 'base',
      }),
    )
    .map(site => ({
      key: site.id,
      name: site.name,
    }))
}
